<template>
  <div>
    <div class="gke-title">
      <div>{{ $t("RAM.GCP.Kubernetes.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:kubernetes:update'
          ]"
          :loading="modal_loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:kubernetes:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="gke-top">
      <elastic-kubernetes-service-search
        ref="search"
      ></elastic-kubernetes-service-search>
    </div>
    <table-elastic-kubernetes-service></table-elastic-kubernetes-service>
  </div>
</template>

<script>
import ElasticKubernetesServiceSearch from "../kubernetes/ElasticKubernetesServiceSearch";
import TableElasticKubernetesService from "../kubernetes/TableElasticKubernetesService";

export default {
  name: "Kubernetes",
  components: {
    ElasticKubernetesServiceSearch,
    TableElasticKubernetesService
  },
  data() {
    return {
      modal_loading: false,
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.companyId = this.$refs.search.companyId;

      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 403
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });

      // 获取子组件数据
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportGcpGke({
          companyId: this.$refs.search.companyId,
          accountName: this.$refs.search.accountName,
          clusterName: this.$refs.search.clusterName
        })
        .then(res => {
          let fileName = "GKE.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.gke-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.gke-title > div:nth-child(1) {
  float: left;
}
.gke-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.gke-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/kubernetes/Kubernetes.vue